export const LogoutSvg = () => (
  <svg width="20" height="20" viewBox="0 0 30 29" fill="none">
    <path
      d="M22.5 6.44444L20.385 8.71611L24.255 12.8889H9V16.1111H24.255L20.385 20.2678L22.5 22.5556L30 14.5L22.5 6.44444ZM3 3.22222H15V0H3C1.35 0 0 1.45 0 3.22222V25.7778C0 27.55 1.35 29 3 29H15V25.7778H3V3.22222Z"
      fill="var(--theme-warning-red)"
    />
  </svg>
);
